export default "__VITE_ASSET__cd656137__"